import { homeTestimonials } from '../../../mocks/testimonials';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const HomeTestimonials = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.2 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.08 });
  const { ref: logosRef, isVisible: logosVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.2 });

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Header */}
        <div
          ref={headerRef}
          className="text-center mb-10 sm:mb-14"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(28px)',
            transition: 'opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)',
          }}
        >
          <span className="text-xs font-semibold text-violet-600 tracking-widest uppercase mb-3 block">
            學員真實案例
          </span>
          <h2 className="text-3xl font-bold text-navy-800 tracking-tight mb-4">
            他們已經透過 NexusGo 實現職涯躍升
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto text-sm leading-relaxed">
            超過 1,200 位學員的真實成功故事，平均薪資提升 78%
          </p>
        </div>

        {/* Cards */}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {homeTestimonials.map((t, i) => (
            <div
              key={t.id}
              className="bg-slate-50 rounded-2xl p-6 border border-slate-100"
              style={{
                opacity: gridVisible ? 1 : 0,
                transform: gridVisible ? 'translateY(0)' : 'translateY(36px)',
                transition: 'opacity 0.65s cubic-bezier(0.22,1,0.36,1), transform 0.65s cubic-bezier(0.22,1,0.36,1)',
                transitionDelay: `${i * 110}ms`,
              }}
            >
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((s) => (
                  <i key={s} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="text-slate-700 text-sm leading-relaxed mb-5 italic">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-slate-200">
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover object-top"
                  />
                  <div>
                    <div className="font-semibold text-navy-800 text-sm">{t.name}</div>
                    <div className="text-slate-400 text-xs">{t.role}</div>
                  </div>
                </div>
                <span className="text-xs font-bold text-slate-600">
                  @ {t.company}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Company Logos */}
        <div
          ref={logosRef}
          className="mt-10 sm:mt-12 flex items-center justify-center gap-4 sm:gap-8 flex-wrap"
          style={{
            opacity: logosVisible ? 1 : 0,
            transform: logosVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)',
            transitionDelay: '200ms',
          }}
        >
          {[
            { logo: '頭部科技企業', color: '#76B900', count: '180+' },
            { logo: '全球網路公司', color: '#4285F4', count: '220+' },
            { logo: '跨國軟體巨擘', color: '#00A4EF', count: '195+' },
            { logo: '頂尖電商平台', color: '#FF9900', count: '160+' },
            { logo: 'AI 獨角獸', color: '#0866FF', count: '140+' },
            { logo: '全球顧問機構', color: '#003580', count: '85+' },
          ].map((co, i) => (
            <div
              key={co.logo}
              className="flex flex-col items-center gap-1.5"
              style={{
                opacity: logosVisible ? 1 : 0,
                transform: logosVisible ? 'translateY(0)' : 'translateY(16px)',
                transition: 'opacity 0.5s ease, transform 0.5s ease',
                transitionDelay: `${200 + i * 60}ms`,
              }}
            >
              <span className="text-sm font-bold" style={{ color: co.color }}>
                {co.logo}
              </span>
              <span className="text-xs text-slate-400">{co.count} 學員</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HomeTestimonials;
